import { render, staticRenderFns } from "./StringDataRep.vue?vue&type=template&id=84d81592&"
import script from "./StringDataRep.vue?vue&type=script&lang=js&"
export * from "./StringDataRep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports